<template>
  <div class="zxpage">
    <header><span>定制咨询</span></header>
    <div class="subtitle">科橘产品顾问将在第一时间回复您,我们将竭诚为您服务！</div>
    <div class="cc">
      <Row :gutter="40" type="flex">
        <Col span="6">
          <div class="wrap">
            <div class="img-wrap"><img src="~@/assets/images/zx/01.png" alt=""></div>
            <div class="name">微信</div>
            <div class="desc">微信号：kejukeji001</div>
          </div>
        </Col>
        <Col span="6">
          <div class="wrap">
            <div class="img-wrap"><img src="~@/assets/images/zx/02.png" alt=""></div>
            <div class="name">E-mail</div>
            <div class="desc">info@otechsolution.com</div>
          </div>
        </Col>
        <Col span="6">
          <div class="wrap">
            <div class="img-wrap"><img src="~@/assets/images/zx/03.png" alt=""></div>
            <div class="name">热线电话</div>
            <div class="desc">400-099-9825</div>
          </div>
        </Col>
        <Col span="6">
          <div class="wrap">            
            <div class="img-wrap"><img src="~@/assets/images/zx/04.png" alt=""></div>
            <div class="name">在线咨询</div>
            <div class="desc"><img src="~@/assets/images/zx/5.png" class="code-img" alt=""></div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZX'
}
</script>

<style scoped>
.zxpage{
  margin-top: 40px;
}
header{
  text-align: center;
}
header span{
  position: relative;
  font-size: 2.6rem;
  font-weight: bold;
  color: #333;
}
header span:before,
header span:after{
  content: "";
  position: absolute;
  height: 1px;
  background-color: #ffa000;
  width: 300px;
  top: 50%;
  transform: translateY(-50%);
}
header span:before{
  left: -320px;
}
header span:after{
  right: -320px;
}
.subtitle{
  font-size: 16px;
  text-align: center;
  margin-top: 12px;
}
.cc{
  margin-top: 50px;
  text-align: center;
}
.img-wrap{
  width:64px;
  height: 64px;
  margin: 0 auto; 
  display: flex;
 align-items: center;
 justify-content: space-around;
 background: #194798;
 border-radius: 50%;

}
.img-wrap img{
  width: 35px;
  height: 35px;
  /* margin: 0 auto; */
  /* display: block; */
}
.cc .code-img{
  width: 64px;
  margin: 0 auto;
  display: block;
}
.cc .name{
  font-size: 16px;
  margin-top: 10px;
  color: #2c6df8;
}
.cc .desc{
  font-size: 14px;
  margin-top: 20px;
}
.cc .desc {
  position: relative;
  min-height: 90px;
  color: #333;
}
.cc .desc img{
  width: 100px;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translateX(-50%);
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .zxpage header span{
    font-size: 3rem;
  }
  .zxpage .subtitle{
    font-size: 18px;
  }
  .zxpage .cc .name{
    font-size: 18px;
  }
  .zxpage .cc .desc{
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/ZX.vue